import { render, staticRenderFns } from "./Myreservation.vue?vue&type=template&id=9c620db2&"
import script from "./Myreservation.vue?vue&type=script&lang=js&"
export * from "./Myreservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports